<template>
  <div class="EmpleadosNuevo">
    <div class="row">
      <div class="col-sm-10 col-md-8 col-sm-offset-1 col-md-offset-2">
        <md-card>
          <md-card-header>
            <div class="md-title">Registrar un empleado nuevo</div>
          </md-card-header>
          <md-card-content>
            <div class="row">
              <div class="col-sm-4">
                <md-field :class="v.nombre_emp">
                  <label>Nombre</label>
                  <md-input v-model="empleado.nombre_emp" required></md-input>
                </md-field>
              </div>
              <div class="col-sm-4">
                <md-field :class="v.ap_pat_emp">
                  <label>Apellido paterno</label>
                  <md-input v-model="empleado.ap_pat_emp" required></md-input>
                </md-field>
              </div>
              <div class="col-sm-4">
                <md-field :class="v.ap_mat_emp">
                  <label>Apellido materno</label>
                  <md-input v-model="empleado.ap_mat_emp" required></md-input>
                </md-field>
              </div>
              <div class="col-sm-4">
                <md-field :class="v.correo_emp">
                  <label>Correo electrónico</label>
                  <md-input v-model="empleado.correo_emp" type="email" required></md-input>
                  <span class="md-helper-text">Con el correo electrónico podrá ingresar a la plataforma</span>
                </md-field>
              </div>
              <div class="col-sm-4">
                <md-field :class="v.tipo_emp">
                  <label for="tipo_emp">Tipo de empleado</label>
                  <md-select v-model="empleado.tipo_emp" name="tipo_emp" id="tipo_emp">
                    <md-option value="administrador">Administrador</md-option>
                    <md-option value="otro">Otro</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <md-button to="/empleados">Cancelar</md-button>
            <md-button class="md-raised md-accent" @click.native="guardarEmpleado()">Guardar</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmpleadosNuevo",
  methods: {
    guardarEmpleado() {
      if (this.validarCamposEmpleado()) {
        this.$http
          .post("empleados/guardar", {
            token: this.$session.get("token"),
            data: this.empleado
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                this.$parent.sb.texto = response.body.msg;
                this.$router.push({
                  name: "EmpleadosListado"
                });
              } else {
                this.$parent.sb.texto = response.body.error;
              }
              this.$parent.sb.mostrar = true;
            },
            response => {
              this.$parent.sb.texto =
                "No se pudo establecer conexión con el servidor para guardar el empleado. Inténtelo de nuevo.";
              this.$parent.sb.mostrar = true;
            }
          );
      }
    },
    validarCamposEmpleado() {
      this.v.nombre_emp = !this.empleado.nombre_emp ? "md-invalid" : false;
      this.v.ap_pat_emp = !this.empleado.ap_pat_emp ? "md-invalid" : false;
      this.v.ap_mat_emp = !this.empleado.ap_mat_emp ? "md-invalid" : false;
      this.v.correo_emp = !this.empleado.correo_emp ? "md-invalid" : false;
      this.v.tipo_emp = !this.empleado.tipo_emp ? "md-invalid" : false;
      if (
        this.v.nombre_emp ||
        this.v.ap_pat_emp ||
        this.v.ap_mat_emp ||
        this.v.correo_emp ||
        this.v.tipo_emp
      ) {
        this.$parent.sb.texto = "Por favor llene los campos marcados con *";
        this.$parent.sb.mostrar = true;
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      empleado: {
        nombre_emp: null,
        ap_pat_emp: null,
        ap_mat_emp: null,
        correo_emp: null,
        tipo_emp: null,
        estatus_emp: "activo"
      },
      v: {
        nombre_emp: null,
        ap_pat_emp: null,
        ap_mat_emp: null,
        correo_emp: null,
        tipo_emp: null,
        estatus_emp: null
      }
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  }
};
</script>